<!-- Строка read-only данных внутри карточки заказа -->
<template>
  <div
    class="order-info-field"
    :class="{ 'order-info-field--inline-on-wide': inlineOnWide }"
  >
    <span class="order-info-field__label">
      <BaseInfoTooltip
        v-if="displayInfo"
        :text="displayInfo"
        :filled="fieldFilled"
        variant="text"
      >
        {{ label }}
      </BaseInfoTooltip>
      <span v-else>{{ label }}</span>
    </span>
    <span class="order-info-field__value" v-if="!$slots.default">
      {{ displayValue }}
    </span>
    <span class="order-info-field__value" v-else>
      <slot />
    </span>
  </div>
</template>

<script>
import { fieldInfoByKey } from "@/config/fieldInfo";

export default {
  name: "OrderInfoField",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    emptyValue: {
      type: String,
      default: "—",
    },
    info: {
      type: String,
      default: "",
    },
    infoKey: {
      type: String,
      default: "",
    },
    filled: {
      type: Boolean,
      default: null,
    },
    // Совпадает с BaseInfoField: на широких экранах держит label и value в одну строку
    inlineOnWide: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayValue() {
      if (this.value === null || this.value === undefined || this.value === "") {
        return this.emptyValue;
      }

      return this.value;
    },

    displayInfo() {
      return this.info || fieldInfoByKey(this.infoKey);
    },

    fieldFilled() {
      if (this.filled !== null) return this.filled;

      return this.value !== null && this.value !== undefined && this.value !== "";
    },
  },
};
</script>

<style scoped>
.order-info-field {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 15px;
}

.order-info-field:last-child {
  margin-bottom: 0;
}

.order-info-field__label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #666;
  font-size: 14px;
  flex-shrink: 0;
}

.order-info-field__value {
  color: var(--color-dark);
  font-weight: 500;
  text-align: right;
  word-break: break-word;
}

@media (max-width: 1200px) {
  .order-info-field--inline-on-wide {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .order-info-field--inline-on-wide .order-info-field__value {
    text-align: left;
  }
}

@media (min-width: 1600px) {
  .order-info-field--inline-on-wide {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    column-gap: 15px;
  }

  .order-info-field--inline-on-wide .order-info-field__value {
    text-align: right;
  }
}
</style>
